import { render } from "./SearchInput.vue?vue&type=template&id=0f4cb23a&ts=true"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=0f4cb23a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__